import { Record, Map, OrderedMap } from 'immutable';

export const JsObjectUtil = {
  // @ts-ignore
  mapToArrayOfJsObjects: (recordsMap: Map<string, unknown>, mappingFunc: ((record: Record | (<TProps>(defaultValues: TProps, name?: string) => Record.Factory<TProps>)) => Object) | null) => {
    const localMappingFunc = mappingFunc ? mappingFunc : (record: any) => record && record.toJS();

    return recordsMap
      ? recordsMap
        .valueSeq()
        .map((record) => {
           // @ts-ignore
          return localMappingFunc(record);
        })
        .toJS()
      : [];
  },

  indexArrayToOrderedMap: (
    jsArray: Array<Object>,
    recordCreator: (model: any, index: number) => undefined | any,
    indexField: string
  ) => {
    return jsArray
      ? OrderedMap(
        jsArray.map((jsObject, index) => {
          let record = recordCreator(jsObject, index);
          if (record.get) {
            return [record.get(indexField), record];
          }
          return [record[indexField], record];
        })
      )
      : OrderedMap();
  },
  
  arrayUnique: (array: any[]) => {
    let a = array.concat();
    for(let i=0; i<a.length; ++i) {
      for(let j=i+1; j<a.length; ++j) {
        if(a[i] === a[j])
          a.splice(j--, 1);
      }
    }
    
    return a;
  }
};
